import { GET_ENC, POST_ENC } from "../common/EncryptedHttp";
import { BASE_URL } from "../common/const";

const BASE = `${BASE_URL}/api/OpthalVisualAcuity`;

// Unaided Distance VA
export const GetUnaidedDistanceVAList = (params: any) =>
  GET_ENC(`${BASE}/GetUnaidedDistanceVAList?` + params, null);

export const GetUnaidedDistanceVADetail = (params: any) =>
  GET_ENC(`${BASE}/GetUnaidedDistanceVADetail?` + params, null);

export const CreateUnaidedDistanceVA = (data: any) =>
  POST_ENC(`${BASE}/CreateUnaidedDistanceVA`, data);

export const UpdateUnaidedDistanceVA = (data: any) =>
  POST_ENC(`${BASE}/UpdateUnaidedDistanceVA`, data);

export const DeleteUnaidedDistanceVA = (data: any) =>
  POST_ENC(`${BASE}/DeleteUnaidedDistanceVA`, data);

// Pinhole VA
export const GetPinholeVAList = (params: any) =>
  GET_ENC(`${BASE}/GetPinholeVAList?` + params, null);

export const GetPinholeVADetail = (params: any) =>
  GET_ENC(`${BASE}/GetPinholeVADetail?` + params, null);

export const CreatePinholeVA = (data: any) =>
  POST_ENC(`${BASE}/CreatePinholeVA`, data);

export const UpdatePinholeVA = (data: any) =>
  POST_ENC(`${BASE}/UpdatePinholeVA`, data);

export const DeletePinholeVA = (data: any) =>
  POST_ENC(`${BASE}/DeletePinholeVA`, data);

// Best Corrected VA
export const GetBestCorrectedVAList = (params: any) =>
  GET_ENC(`${BASE}/GetBestCorrectedVAList?` + params, null);

export const GetBestCorrectedVADetail = (params: any) =>
  GET_ENC(`${BASE}/GetBestCorrectedVADetail?` + params, null);

export const CreateBestCorrectedVA = (data: any) =>
  POST_ENC(`${BASE}/CreateBestCorrectedVA`, data);

export const UpdateBestCorrectedVA = (data: any) =>
  POST_ENC(`${BASE}/UpdateBestCorrectedVA`, data);

export const DeleteBestCorrectedVA = (data: any) =>
  POST_ENC(`${BASE}/DeleteBestCorrectedVA`, data);

// Near Vision
export const GetNearVisionList = (params: any) =>
  GET_ENC(`${BASE}/GetNearVisionList?` + params, null);

export const GetNearVisionDetail = (params: any) =>
  GET_ENC(`${BASE}/GetNearVisionDetail?` + params, null);

export const CreateNearVision = (data: any) =>
  POST_ENC(`${BASE}/CreateNearVision`, data);

export const UpdateNearVision = (data: any) =>
  POST_ENC(`${BASE}/UpdateNearVision`, data);

export const DeleteNearVision = (data: any) =>
  POST_ENC(`${BASE}/DeleteNearVision`, data);

// Final Visual Acuity
export const GetFinalVAList = (params: any) =>
  GET_ENC(`${BASE}/GetFinalVAList?` + params, null);

export const GetFinalVADetail = (params: any) =>
  GET_ENC(`${BASE}/GetFinalVADetail?` + params, null);

export const CreateFinalVA = (data: any) =>
  POST_ENC(`${BASE}/CreateFinalVA`, data);

export const UpdateFinalVA = (data: any) =>
  POST_ENC(`${BASE}/UpdateFinalVA`, data);

export const DeleteFinalVA = (data: any) =>
  POST_ENC(`${BASE}/DeleteFinalVA`, data);
